import { ca } from '@cian/analytics';

import { TBubbleBody } from '../../types/messageBubble';

export const trackBubbleButtonClick = (chatId: string, bubbleType: string, buttonName: string) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Bubble',
    action: 'Click_sopr',
    label: 'Button',
    page: {
      extra: {
        chat_id: chatId,
        bubble_type: bubbleType,
        button_name: buttonName,
      },
    },
  });
};

/**
 * Содержимое баббла «Инфо о клиенте»: тип баббла на клиенте неизвестен, поэтому отдаём в аналитику
 * всё, что показали пользователю, — сам тип, заголовок, тело баббла и текст кнопки, по которой кликнули.
 */
interface ISubsChatRichBubbleClickParams {
  analyticsBubbleType: string;
  title?: string;
  body: TBubbleBody[] | null;
  buttonTitle: string;
}

/** Клик по кнопке баббла с информацией о клиенте. */
export const trackSubsChatRichBubbleClick = (params: ISubsChatRichBubbleClickParams): void => {
  const { analyticsBubbleType, title, body, buttonTitle } = params;

  ca('eventSite', {
    name: 'oldevent',
    category: 'Chat',
    action: 'Click',
    label: 'SubsChatRichBubble',
    page: {
      extra: {
        analyticsBubbleType,
        title,
        body,
        button_title: buttonTitle,
      },
    },
  });
};
